function injectAndSyncCounter() {
  const containers = document.querySelectorAll('.wishlist-header__icon');
  
  containers.forEach(container => {
    if (!container.querySelector('.wishlist-header__heart_counter')) {
      const counter = document.createElement('span');
      counter.className = 'wishlist-header__heart_counter';
      counter.textContent = '0';
      container.appendChild(counter);
    }
  });
  
  // Update data after insertion
  updateWishlistCount();
}

function updateWishlistCount() {
  const counters = document.querySelectorAll('.wishlist-header__heart_counter');
  // @ts-ignore
  if (!window.Wishlist) return;

  // @ts-ignore
  const count = (Wishlist.get() || []).length;
  
  counters.forEach(counter => {
    counter.textContent = count;
    // @ts-ignore
    counter.style.display = count > 0 ? 'flex' : 'none';
  });
}

// 1. Initialize on page load
document.addEventListener('DOMContentLoaded', injectAndSyncCounter);

// 2. WATCH FOR RE-RENDERING:
// Observe the header parent (for example, the body tag or the header itself)
const header = document.querySelector('.header-wrapper') || document.body;

const observer = new MutationObserver((mutations) => {
  // If DOM changes occur, check whether our counter has disappeared
  const counters = document.querySelectorAll('.wishlist-header__heart_counter');
  if (counters.length === 0) {
    injectAndSyncCounter();
  }
});

observer.observe(header, { childList: true, subtree: true });

// 3. Also listen for events from the library itself
document.addEventListener('wishlist:updated', updateWishlistCount);

window.addEventListener('storage', (e) => {
  if (
    // @ts-ignore
    window.Wishlist &&
    // @ts-ignore
    e.key === Wishlist.key
  ) {
    updateWishlistCount();
  }
});